"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthSwitch = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var ForgotPassword_1 = __importDefault(require("../ForgotPassword/ForgotPassword"));
var ResetPassword_1 = __importDefault(require("../ResetPassword/ResetPassword"));
var Register_1 = __importDefault(require("../Register/Register"));
var Login_1 = __importDefault(require("../Login/Login"));
var AuthSwitch = function (_a) {
    var _b = _a.initialView, initialView = _b === void 0 ? 'LOGIN' : _b, resettoken = _a.resettoken, onLogin = _a.onLogin, onRegister = _a.onRegister;
    var _c = (0, react_1.useState)(initialView), view = _c[0], setView = _c[1];
    switch (view) {
        case 'FORGOT_PASSWORD':
            return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "AuthSwitch_FORGOT_PASSWORD" }, { children: (0, jsx_runtime_1.jsx)(ForgotPassword_1.default, { onCancel: function () { return setView('LOGIN'); } }, void 0) }), void 0));
        case 'RESET_PASSWORD':
            return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "AuthSwitch_RESET_PASSWORD" }, { children: resettoken && (0, jsx_runtime_1.jsx)(ResetPassword_1.default, { onCancel: function () { return setView('LOGIN'); }, resettoken: resettoken }, void 0) }), void 0));
        case 'REGISTER':
            return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "AuthSwitch_REGISTER" }, { children: (0, jsx_runtime_1.jsx)(Register_1.default, { onLogin: function () { return setView('LOGIN'); }, onSubmit: onRegister }, void 0) }), void 0));
        case 'LOGIN':
        default:
            return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "AuthSwitch_LOGIN" }, { children: (0, jsx_runtime_1.jsx)(Login_1.default, { onSubmit: onLogin, onForgotPassword: function () { return setView('FORGOT_PASSWORD'); }, onRegister: function () { return setView('REGISTER'); } }, void 0) }), void 0));
    }
};
exports.AuthSwitch = AuthSwitch;
exports.default = exports.AuthSwitch;
